import { initialState } from 'src/contexts/settings/settings-context';
import { therapyPlanningAction} from '../../actions/constant';

const { GET_THERAPY_PLANNING_PATIENT_SUCCESS,GET_THERAPY_PLANNING_PATIENT_FAILURE } =
  therapyPlanningAction;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
};

export const getIsTherapyPlanningPatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPY_PLANNING_PATIENT_SUCCESS: {
      
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
      };
    }

    case GET_THERAPY_PLANNING_PATIENT_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
      };

    default:
      return state;
  }
};
